import { Box, Paper, Typography, TextField, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import color from "../utils/Colors";
import { resetPassword } from "../../services/services";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../utils/SnackBar";
import { useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
function ResetPasswordComp() {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((show) => !show);
  };
  const { token } = useParams();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: (values) => {
      if (!token) {
        showSnackbar("Invalid or missing reset token");
        return;
      }

      resetPassword({ token, password: values.password })
        .then((result: any) => {
          if (result?.data?.statusCode === 200) {
            showSnackbar(
              result?.data?.message || "Password reset successfully!",
            );
            navigate("/auth");
          }
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message ||
              error?.response?.data?.msg ||
              "Reset failed",
          );
        });
    },
  });

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          px: { xs: 2, sm: 0 },
          border: "2px solid",
          borderColor: color.borderColor,
          borderRadius: "18px",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: { xs: 2, sm: 6 },
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: { xs: "40px", sm: "70px" },
            paddingBottom: { xs: "40px", sm: "70px" },
          }}
        >
          <Typography
            variant="h5"
            align="center"
            sx={{
              color: "#321548",
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: "18px", sm: "20px", md: "22px" },
            }}
          >
            Reset your Password
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            sx={{
              color: "#746283",
              fontWeight: 400,
              mb: 4,
              fontSize: { xs: "9px", sm: "11px", md: "13px" },
            }}
          >
            Enter your new password below
          </Typography>

          <Box component="form" onSubmit={formik.handleSubmit}>
            <TextField
              placeholder="New Password"
              className="input-root2"
              name="password"
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              variant="outlined"
              fullWidth
              sx={{
                mb: 3,
                background: "white",
                borderRadius: 3,
                "& .MuiOutlinedInput-root": { borderRadius: 3 },
              }}
            />

            <TextField
              placeholder="Confirm Password"
              className="input-root2"
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowConfirmPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                background: "white",
                borderRadius: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                },
              }}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#35185A",
                borderRadius: 3,
                textTransform: "none",
              }}
              type="submit"
              disabled={!(formik.isValid && formik.dirty)}
            >
              Reset Password
            </Button>
          </Box>
        </Paper>
      </Box>
    </div>
  );
}

export default ResetPasswordComp;
